var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.894 5H3s4.648 5.54 9.769 8.585a8.973 8.973 0 0 1-2.213-4.299c3.076 3.162 10.513 9.1 20.443 9.45-9.568-2.8-12.314-6.122-12.314-6.122a11.592 11.592 0 0 0 5.145 1.998C25.76 11.162 29.172 5 29.172 5h-8.558l-4.423 8.486L10.893 5zm5.31 23.558 5.7-10.354c-2.5-.88-4.92-1.97-7.236-3.26.7 1.29 1.616 2.452 2.706 3.435-5.819-2.407-9.583-4.371-14.013-7.761 3.994 4.422 7.792 7.627 11.579 9.114a15.115 15.115 0 0 1-4.519-1.59c1.879 3.48 5.784 10.414 5.784 10.414z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyr);
export default __webpack_public_path__ + "static/media/PYR.71a7610838c7e2a0fc6a3a8c35b9ca73.svg";
export { ForwardRef as ReactComponent };